import styled from 'styled-components';

const MinResolutionContainer = styled.div`
  min-height: 100vh;
  width:100%;
  background-image: url('${process.env.PUBLIC_URL}/login_bg.jpg');
  background-size:cover;
  background-color: #1A1A1F;
  position: fixed;
  z-index: ${props => props.theme.zindex.xlarge};
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
`;

const LogoContainer = styled.div`
  padding: 50px 0 25px;
  overflow: hidden;
`;

const VerticalCentered = styled.div`
  min-height: calc(100vh - 164px);
  display: flex;
  align-items: center;
  margin-top: -72px;
`;

export { MinResolutionContainer, LogoContainer, VerticalCentered };
